import React, { useEffect, useState } from "react";
import {
  FALLBACK_IMAGE,
  handleImageError,
  resolvePublicAssetPath,
} from "../../utils/imageFallback";

/**
 * Image that falls back to a shared local asset when the primary src fails.
 */
const SafeImage = ({
  src,
  alt = "",
  className,
  fallbackSrc = FALLBACK_IMAGE,
  ...rest
}) => {
  const resolvedFallback = resolvePublicAssetPath(fallbackSrc, FALLBACK_IMAGE);
  const resolvedSrc = resolvePublicAssetPath(src, resolvedFallback);
  const [currentSrc, setCurrentSrc] = useState(resolvedSrc);

  useEffect(() => {
    setCurrentSrc(resolvePublicAssetPath(src, resolvedFallback));
  }, [src, resolvedFallback]);

  return (
    <img
      src={currentSrc || resolvedFallback}
      alt={alt}
      className={className}
      onError={(event) => {
        if (currentSrc !== resolvedFallback) {
          setCurrentSrc(resolvedFallback);
        }
        handleImageError(event, resolvedFallback);
      }}
      {...rest}
    />
  );
};

export default SafeImage;
